(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-complementary-products-block"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(evt) {
  if (!evt.target.matches('.upsell-add')) return;
  
  var btn = evt.target;
  var item = btn.closest('.upsell-item');
  var select = item.querySelector('.variant-select');
  var vid;

  if (select) {
    vid = select.value;
  } else {
    vid = item.getAttribute('data-variant-id');
  }

  if (!vid) {
    console.error('No variant ID found');
    return;
  }

  btn.disabled = true;
  btn.textContent = 'Přidávám…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json', 
      'Accept': 'application/json' 
    },
    body: JSON.stringify({ 
      id: vid, 
      quantity: 1 
    })
  })
  .then(function(res) { 
    if (!res.ok) {
      throw new Error('Failed to add to cart');
    }
    return res.json(); 
  })
  .then(function(data) {
    btn.textContent = 'Přidáno ✓';
    btn.classList.add('added');
    
    // Optional: Show checkmark in media
    var media = item.querySelector('.upsell-media');
    if (media && !media.querySelector('.check')) {
      media.innerHTML += '<div class="check">✓</div>';
    }
    
    // Optional: Trigger cart drawer update
    if (typeof window.dispatchEvent === 'function') {
      window.dispatchEvent(new Event('cart:refresh'));
    }
    
    setTimeout(function() {
      btn.disabled = false;
    }, 2000);
  })
  .catch(function(error) {
    console.error('Error:', error);
    btn.disabled = false;
    btn.textContent = 'Chyba – zkuste znovu';
  });
});
  } catch(e) { console.error(e); }
})();

})();
